<template>
  <ButtonElement class="btn btn-default btn-grey tag" :class="tagClass" @click="removeTag">
    <span class="tag-title">
      {{ title }}
    </span>
    <span class="tag-remove" v-if="withCloseButton">
      <LucideIcon  icon="X" />
    </span>
  </ButtonElement>
</template>
<script lang="ts">
import { defineComponent, type PropType } from 'vue';

import { ButtonElement } from '@shared/components/elements';

export default defineComponent({
  name: 'TagButtonElement',
  components: {
    ButtonElement,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    withCloseButton: {
      type: Boolean,
      default: false,
    },
    class: {
      type: String as PropType<
        | 'tag-default'
        | 'tag-google'
        | 'tag-grey'
        | 'tag-light-grey'
        | 'btn-purple'
        | 'btn-grey'
      >,
      default: 'tag-light-grey',
    },
  },
  data() {
    return {
      tagClass: this.class,
    };
  },
  methods: {
    removeTag() {
      this.$emit('tagRemove');
    },
  },
});
</script>
<style lang="scss" scoped>

  .btn{
    &:hover{
      .tag-remove{
        display: flex;
      }
    }
    .tag-remove{
      display: none;
    }
  }
  .tag {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: var(--fs-14);
    height: 24px;
    padding: var(--space-0) var(--space-6);
    margin: var(--space-0);
    border-radius: $br-sm;
    line-height: 20px;

    .tag-remove {
      margin-left: var(--space-6);

      &:hover {
        cursor: pointer;
      }
    }
}
</style>
